import React from 'react'
import Footer from './Footer'
import NavBar from "./NavBar"
import "./LandingPage.css"
 
import Hero from './Hero'
function LandingPage() {
   return(
    <div>
        <NavBar />
        <Hero />
        <Footer />

    </div>
   )
}

export default LandingPage